/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect, useRef } from 'react'
import { useTrans } from 'hooks'
import { prodottoCardMock } from 'utils/mock'
import {
  StepBar,
  Button,
  FormField,
  FormCheckbox,
  FormLayout,
  NotificationBar,
} from 'components/atoms'
import {
  RiepilogoOrdine,
  RiepilogoProdottiCheckout,
  RiepilogoSpedizioneCheckout,
  BannerInformativo,
  PayPalMessage,
} from 'components/molecules'
import {
  Page,
  CheckoutShippingAddressStepBlock,
  CheckoutBillingAddressStepBlock,
  CheckoutShippingMethodStepBlock,
  CheckoutPaymentMethodStepBlock,
} from 'components/organisms'
import { executeIfInitialized, trackConnectifCart } from 'utils/connectif'

import { CreditCard } from 'components/atoms/Icons'
import { priceNotation } from 'utils/safe'
import { gql, useMutation, useQuery } from '@apollo/client'
import { useRouter } from 'next/router'
import {
  CHECKOUT,
  SET_CHECKOUT,
  CREATE_INDIRIZZO,
  SET_INDIRIZZI,
  INDIRIZZI_FATTURAZIONE,
  INDIRIZZI_SPEDIZIONE,
  SISTEMI_SPEDIZIONE_SENZA_INDIRIZZO,
} from 'utils/queries'
import { createIndirizzoInput } from 'utils/indirizzo'
import { useSetCheckoutMutation, useUpdateUtenteMutation } from 'gql/graphql'
import { FUNDING } from '@paypal/react-paypal-js'
import PaypalFormContainer from 'components/organisms/PaypalForm/PaypalForm'
import PaypalButton from 'components/molecules/PaypalButton/PaypalButton'
import { useIsMobile } from 'hooks'
import { DOMAIN } from 'utils/settings'
import { trackingCheckout, trackingGAevent } from 'utils/gtm'
import { getCurrentDate } from 'utils'

const CheckoutTemplate = ({ pagina }) => {
  const isMobile = useIsMobile()

  const [addMessage, setAddMessage] = useState('')
  const {
    loading: checkoutLoading,
    data,
    error,
    refetch,
  } = useQuery(
    gql`
      ${CHECKOUT}
    `,
    { fetchPolicy: 'network-only' }
  )

  const { data: indirizziSpedizione } = useQuery(
    gql`
      ${INDIRIZZI_SPEDIZIONE}
    `
  )
  const { data: indirizziFatturazione } = useQuery(
    gql`
      ${INDIRIZZI_FATTURAZIONE}
    `
  )

  const { data: sistemiSpedizioneSenzaIndirizzo, refetch: refetchSistemiSpedizione } = useQuery(
    gql`
      ${SISTEMI_SPEDIZIONE_SENZA_INDIRIZZO}
    `
  )

  //const [getQuoteShippingEstero] = useMutation(gql`${GET_QUOTE_SHIPPING_ESTERO}`)

  useEffect(() => {
    if (data?.checkout?.indirizzoSpedizione?.cap) {
      refetchSistemiSpedizione({
        cap: data.checkout.indirizzoSpedizione.cap,
      })
      if (data?.checkout?.sistemaSpedizione?.estero) {
        let items_omaggio_to_remove = data?.checkout.items.filter(
          (item) => item.omaggio && !item.prodotto.prodotto.vendibileEstero
        )
        if (items_omaggio_to_remove.length > 0) {
          setOmaggioEstero(true)
        }
      }
    }
  }, [data?.checkout?.indirizzoSpedizione?.cap])

  const router = useRouter()

  useEffect(() => {
    handleRedirect(data?.checkout)
  }, [data?.checkout])

  function handleRedirect(checkout) {
    if (!checkoutLoading && !checkout?.items.length) router.replace('/carrello')
  }

  const t = useTrans()
  const [activeStepIndex, setActiveStepIndex] = useState(2)
  const [riepilogoMobileOpen, setRiepilogoMobileOpen] = useState(false)
  const [swipeStart, setSwipeStart] = useState(null)
  const [paypalClicked, setPaypalClicked] = useState(false)
  const steps = [t('Carrello'), t('Spedizione'), t('Pagamento')]

  useEffect(() => {
    if (riepilogoMobileOpen) document.body.classList.add('w-noscroll')
    else document.body.classList.remove('w-noscroll')
  }, [riepilogoMobileOpen])

  const handleSwipeStart = (e) => setSwipeStart(e.changedTouches[0].screenY)

  const handleSwipeEnd = (e) => {
    if (swipeStart !== null) {
      setRiepilogoMobileOpen(e.changedTouches[0].screenY < swipeStart)
    }
    setSwipeStart(null)
  }

  const [createIndirizzo] = useMutation(
    gql`
      ${CREATE_INDIRIZZO}
    `
  )
  const [setIndirizziCheckout] = useMutation(
    gql`
      ${SET_INDIRIZZI}
    `
  )

  const [addedShippingAddress, setAddedShippingAddress] = useState(null)
  const shippingAddressRef = useRef<any>()
  const [addedBillingAddress, setAddedBillingAddress] = useState(null)
  const billingAddressRef = useRef<any>()

  const gotoPayment = async () => {
    if (data?.checkout) {
      if (
        !data.checkout.sistemaSpedizione ||
        (indirizziSpedizione.indirizzi.edges.length === 0 &&
          !shippingAddressRef?.current?.isValid) ||
        (indirizziSpedizione.indirizzi.edges.length !== 0 && !data.checkout.indirizzoSpedizione) ||
        (indirizziSpedizione.indirizzi.edges.length !== 0 &&
          !indirizziSpedizione.indirizzi.edges.find(
            (i) => i.node.pk === data.checkout.indirizzoSpedizione?.pk
          ) &&
          addedShippingAddress?.pk !== null &&
          addedShippingAddress?.pk !== data.checkout.indirizzoSpedizione?.pk) ||
        (data.checkout.richiediFattura &&
          indirizziFatturazione.indirizzi.edges.length === 0 &&
          !billingAddressRef?.current?.isValid) ||
        (data.checkout.richiediFattura &&
          indirizziFatturazione.indirizzi.edges.length !== 0 &&
          !data.checkout.indirizzoFatturazione) ||
        (data.checkout.richiediFattura &&
          indirizziFatturazione.indirizzi.edges.length !== 0 &&
          !indirizziFatturazione.indirizzi.edges.find(
            (i) => i.node.pk === data.checkout.indirizzoFatturazione?.pk
          ) &&
          addedBillingAddress?.pk !== null &&
          addedBillingAddress?.pk !== data.checkout.indirizzoFatturazione?.pk) ||
        (sistemiSpedizioneSenzaIndirizzo?.sistemiSpedizioneSenzaIndirizzo.length !== 0 &&
          !sistemiSpedizioneSenzaIndirizzo.sistemiSpedizioneSenzaIndirizzo.find(
            (i) => i.pk === data.checkout.sistemaSpedizione?.pk
          ))
      ) {
        return
      }
      if (data.checkout.indirizzoSpedizione && !data.checkout.indirizzoSpedizione.telefono) {
        setAddMessage("Errore: Il campo telefono dell'indirizzo di spedizione è vuoto.")
        return
      }

      if (
        data.checkout.richiediFattura &&
        indirizziFatturazione.indirizzi.edges.length === 0 &&
        billingAddressRef?.current.isValid
      ) {
        const values = billingAddressRef.current.values

        await createIndirizzo({
          variables: {
            input: createIndirizzoInput(values),
          },
        }).then(async (res) => {
          const indirizzo = res.data.createIndirizzo.indirizzo

          await setIndirizziCheckout({
            variables: {
              indirizzoFatturazione: indirizzo.pk,
            },
          })
        })
      }
    }
    await refetch()
    setActiveStepIndex(3)
    setRiepilogoMobileOpen(false)
  }

  const [updateUtente] = useUpdateUtenteMutation()
  const [setCheckout, { data: setCheckoutPayload }] = useSetCheckoutMutation()
  const [condizioni, setCondizioni] = useState(false)
  const [newsletter, setNewsletter] = useState(false)
  const [errorCondizioni, setErrorCondizioni] = useState(false)
  const [paypalCompleted, setPaypalCompleted] = useState(false)
  const [omaggioEstero, setOmaggioEstero] = useState(false)

  useEffect(() => {
    if (paypalClicked) {
      if (data?.checkout) {
        if (data.checkout.indirizzoSpedizione && !data.checkout.indirizzoSpedizione.telefono) {
          setAddMessage("Errore: Il campo telefono dell'indirizzo di spedizione è vuoto.")
        } else {
          setAddMessage('')
        }
      }
    }
  }, [paypalClicked, data?.checkout?.indirizzoSpedizione])

  useEffect(() => {
    if (paypalCompleted) {
      confirmOrder()
    }
  }, [paypalCompleted])

  const handleCheckoutRedirect = (response) => {
    if (response.url) {
      //localStorage.setItem('checkout', JSON.stringify(checkout)) // per TYP
      window.location.href = response.url // force SSR
    }
  }

  useEffect(() => {
    if (setCheckoutPayload?.setCheckout && data?.checkout.sistemaPagamento?.chiave === 'bonifico')
      handleCheckoutRedirect(setCheckoutPayload?.setCheckout)
  }, [setCheckoutPayload?.setCheckout])

  const confirmOrder = async () => {
    // !condizioni && setErrorCondizioni(true)
    if (data?.checkout.sistemaPagamento && condizioni) {
      await setCheckout({
        variables: {
          sistemaPagamento: data?.checkout.sistemaPagamento?.pk,
        },
      }).then(async (res) => {
        try {
          if (newsletter) {
            await updateUtente({
              variables: {
                input: {
                  privacyCommerciale: newsletter,
                },
              },
            }).then((response) => {
              if (response?.data?.updateUtente?.iscrizioneNewsletter) {
                trackingGAevent(2, 'user', 'newsletter', DOMAIN + router.asPath, getCurrentDate())
              }
            })
          }
        } catch (e) {
          console.log(e)
        }
        typeof window !== 'undefined' && (window.location.href = res.data.setCheckout.url)
      })
    }
  }

  const [trackingSpedizioneSent, setTrackingSpedizioneSent] = useState(false)
  const [trackingPagamentoSent, setTrackingPagamentoSent] = useState(false)

  useEffect(() => {
    if (data?.checkout && activeStepIndex === 2 && !trackingSpedizioneSent && !checkoutLoading) {
      trackingCheckout(data?.checkout, 2, '')
      executeIfInitialized(trackConnectifCart, data?.checkout)
      setTrackingSpedizioneSent(true)
    }
    if (data?.checkout && activeStepIndex === 3 && !trackingPagamentoSent && !checkoutLoading) {
      trackingCheckout(data?.checkout, 3, data?.checkout?.sistemaSpedizione?.nome)
      executeIfInitialized(trackConnectifCart, data?.checkout)
      setTrackingPagamentoSent(true)
    }
  }, [activeStepIndex, data?.checkout])

  return (
    <Page
      hideHead
      headerType="minimal"
      footerType="none"
      hidePrefooter
      pagina={pagina}
      backButton={{
        label: t('Torna al carrello'),
        labelMobile: t('Carrello'),
        href: '/carrello',
      }}
      className="checkout-template"
    >
      <StepBar
        steps={steps}
        activeStepIndex={activeStepIndex}
        className="checkout-template__stepbar"
      />

      {activeStepIndex === 3 && (
        <NotificationBar
          label={t('Paga in sicurezza con tutti i nostri metodi di pagamento')}
          icon={<CreditCard />}
          variant="success"
          className="checkout-template__security-notification"
        />
      )}
      <div className="checkout-template__layout">
        <div className="checkout-template__main">
          {activeStepIndex === 2 && paypalClicked === true && (
            <BannerInformativo
              description={t(
                'Hai selezionato Paypal come metodo di pagamento.<br>Ti chiediamo alcuni dati prima di procedere al pagamento sulla piattaforma di Paypal'
              )}
              imageUrl="/images/paypal_big.png"
            />
          )}
          {activeStepIndex === 2 && omaggioEstero === true && (
            <BannerInformativo
              description={t(
                'Attenzione, la promo Omagggio non può essere applicata ad ordini esteri.Il prodotto omaggio verrà rimosso.'
              )}
              imageUrl="/images/alert_icon.png"
              className="error"
            />
          )}
          {activeStepIndex === 2 && (
            <>
              {addMessage && addMessage !== '' && (
                <NotificationBar variant="alert" label={addMessage} />
              )}

              <CheckoutShippingAddressStepBlock
                indirizziSpedizione={indirizziSpedizione}
                shippingAddressRef={shippingAddressRef}
                shippingAddressAttivo={data?.checkout.indirizzoSpedizione?.pk}
                checkoutLoading={checkoutLoading}
                addedShippingAddress={addedShippingAddress}
                setAddedShippingAddress={setAddedShippingAddress}
                refetchSistemiSpedizione={refetchSistemiSpedizione}
              />
              {
                <CheckoutBillingAddressStepBlock
                  indirizziFatturazione={indirizziFatturazione}
                  billingAddressRef={billingAddressRef}
                  billingAddressAttivo={data?.checkout.indirizzoFatturazione?.pk}
                  richiediFattura={
                    data?.checkout.richiediFattura && !data?.checkout.sistemaSpedizione?.estero
                  }
                  addedBillingAddress={addedBillingAddress}
                  setAddedBillingAddress={setAddedBillingAddress}
                  estero={data?.checkout.sistemaSpedizione?.estero}
                />
              }

              <CheckoutShippingMethodStepBlock
                shippingMethods={sistemiSpedizioneSenzaIndirizzo?.sistemiSpedizioneSenzaIndirizzo}
                shippingMethodAttivo={data?.checkout.sistemaSpedizione?.pk}
              />
            </>
          )}

          {activeStepIndex === 2 && isMobile && paypalClicked == true && (
            <div className="checkout-template__privacy-mobile">
              <FormLayout>
                <FormField
                  layout="full"
                  errorMessage="Campo obbligatorio"
                  status={errorCondizioni ? 'error' : undefined}
                >
                  <FormCheckbox
                    id="checkout-template__privacy-mobile"
                    label={`*${t('Accetto le condizioni generali di vendita del sito.')}`}
                    checked={condizioni}
                    onChange={() => {
                      setCondizioni(!condizioni)
                      setErrorCondizioni(condizioni)
                    }}
                  />
                </FormField>
                <FormField layout="full">
                  <FormCheckbox
                    id="checkout-template__newsletter-mobile"
                    label={t('Voglio iscrivermi alla newsletter')}
                    checked={newsletter}
                    onChange={() => setNewsletter(!newsletter)}
                  />
                </FormField>
              </FormLayout>
            </div>
          )}

          {activeStepIndex === 3 && (
            <>
              <RiepilogoSpedizioneCheckout
                onEdit={() => setActiveStepIndex(2)}
                checkout={data?.checkout}
                className="checkout-template__riepilogo-spedizione"
              />
              <div>
                {/* serve per la gestione dei bordi - non rimuovere */}
                <CheckoutPaymentMethodStepBlock
                  paymentMethods={data?.checkout.sistemiPagamento}
                  paymentMethodAttivo={data?.checkout.sistemaPagamento.pk}
                  paypalFormContent={
                    <PaypalFormContainer
                      confirmOrder={() => setPaypalCompleted(true)}
                      disabled={!condizioni}
                    />
                  }
                />
              </div>
              {/* Duplicato tra desktop (in mezzo alla sidebar) e mobile (qui) - unificare la logica */}
              <div className="checkout-template__privacy-mobile">
                <FormLayout>
                  <FormField
                    layout="full"
                    errorMessage="Campo obbligatorio"
                    status={errorCondizioni ? 'error' : undefined}
                  >
                    <FormCheckbox
                      id="checkout-template__privacy-mobile"
                      label={`*${t('Accetto le condizioni generali di vendita del sito.')}`}
                      checked={condizioni}
                      onChange={() => {
                        setCondizioni(!condizioni)
                        setErrorCondizioni(condizioni)
                      }}
                    />
                  </FormField>
                  <FormField layout="full">
                    <FormCheckbox
                      id="checkout-template__newsletter-mobile"
                      label={t('Voglio iscrivermi alla newsletter')}
                      checked={newsletter}
                      onChange={() => setNewsletter(!newsletter)}
                    />
                  </FormField>
                </FormLayout>
              </div>
            </>
          )}
        </div>
        {riepilogoMobileOpen && (
          <div
            className="checkout-template-sidebar-overlay"
            onClick={() => setRiepilogoMobileOpen(false)}
          />
        )}
        <div
          className={`checkout-template__sidebar${
            riepilogoMobileOpen ? ' checkout-template__sidebar--open' : ''
          }`}
        >
          <button
            type="button"
            className="checkout-template__swiper-mobile"
            onTouchStart={handleSwipeStart}
            onTouchEnd={handleSwipeEnd}
            onClick={() => setRiepilogoMobileOpen(!riepilogoMobileOpen)}
          />
          <div className="checkout-template__riepilogo-mobile">
            <RiepilogoOrdine
              checkout
              ordine={{
                totaleProdotti: data?.checkout.totaleProdottiScontato,
                speseSpedizione: data?.checkout.sistemaSpedizione.estero
                  ? data?.checkout.spedizioneEstero
                  : data?.checkout.sistemaSpedizione.prezzoScontato,
                scontoAssoluto: data?.checkout.scontoAssoluto,
                totale: data?.checkout.totaleScontato,
                promo: data?.checkout.promoApplicata,
                speseContrassegno:
                  data?.checkout.sistemaPagamento?.chiave === 'contrassegno'
                    ? data.checkout.sistemaPagamento.prezzo
                    : null,
              }}
              paypalClicked={paypalClicked}
              setPaypalClicked={setPaypalClicked}
              accise={data?.checkout?.accise}
              iva={data?.checkout?.iva}
              estero={data?.checkout?.sistemaSpedizione.estero}
              erroreApisEstero={data?.checkout?.erroreApisEstero}
            />

            {activeStepIndex === 2 && paypalClicked === true && (
              <div className="checkout-template__privacy-desktop">
                <FormLayout>
                  <FormField
                    layout="full"
                    status={errorCondizioni ? 'error' : undefined}
                    errorMessage="Campo obbligatorio"
                  >
                    <FormCheckbox
                      id="checkout-template__privacy"
                      label={`*${t('Accetto le condizioni generali di vendita del sito.')}`}
                      checked={condizioni}
                      onChange={() => {
                        setCondizioni(!condizioni)
                        setErrorCondizioni(condizioni)
                      }}
                    />
                  </FormField>
                  <FormField layout="full">
                    <FormCheckbox
                      id="checkout-template__newsletter"
                      label={t('Voglio iscrivermi alla newsletter')}
                      checked={newsletter}
                      onChange={() => setNewsletter(!newsletter)}
                    />
                  </FormField>
                </FormLayout>
                {
                  <div className="checkout-template__paypal">
                    <PaypalButton
                      confirmOrder={() => setPaypalCompleted(true)}
                      isValid={
                        (!data?.checkout?.sistemaSpedizione.estero && !condizioni) ||
                        (data?.checkout?.sistemaSpedizione.estero &&
                          (data?.checkout?.erroreApisEstero || !condizioni)) ||
                        addMessage
                      }
                      fundingSource={FUNDING.PAYPAL}
                    />
                    <div className="checkout-template__paypal__message">
                      <PayPalMessage
                        style={{ layout: 'text' }}
                        forceReRender={[{ layout: 'text' }]}
                      />
                    </div>
                  </div>
                }
              </div>
            )}
            {activeStepIndex === 2 && paypalClicked === false && (
              <Button
                label={t('Procedi')}
                className="checkout-template__next"
                disabled={
                  (data?.checkout?.sistemaSpedizione.estero && data?.checkout?.erroreApisEstero) ||
                  indirizziSpedizione?.indirizzi?.edges?.length === 0
                }
                onClick={() => gotoPayment()}
              />
            )}
            {activeStepIndex === 3 && (
              <div className="checkout-template__privacy-desktop">
                <FormLayout>
                  <FormField
                    layout="full"
                    status={errorCondizioni ? 'error' : undefined}
                    errorMessage="Campo obbligatorio"
                  >
                    <FormCheckbox
                      id="checkout-template__privacy"
                      label={`*${t('Accetto le condizioni generali di vendita del sito.')}`}
                      checked={condizioni}
                      onChange={() => {
                        setCondizioni(!condizioni)
                        setErrorCondizioni(condizioni)
                      }}
                    />
                  </FormField>
                  <FormField layout="full">
                    <FormCheckbox
                      id="checkout-template__newsletter"
                      label={t('Voglio iscrivermi alla newsletter')}
                      checked={newsletter}
                      onChange={() => setNewsletter(!newsletter)}
                    />
                  </FormField>
                </FormLayout>
                {data?.checkout.sistemaPagamento?.chiave === 'paypal_login' && !isMobile ? (
                  <div className="checkout-template__paypal">
                    <PaypalButton
                      confirmOrder={() => setPaypalCompleted(true)}
                      isValid={
                        (!data?.checkout?.sistemaSpedizione.estero && !condizioni) ||
                        (data?.checkout?.sistemaSpedizione.estero &&
                          (data?.checkout?.erroreApisEstero || !condizioni))
                      }
                      fundingSource={FUNDING.PAYPAL}
                    />
                    <div className="checkout-template__paypal__message">
                      <PayPalMessage
                        style={{ layout: 'text' }}
                        forceReRender={[{ layout: 'text' }]}
                      />
                    </div>
                  </div>
                ) : (
                  <Button
                    id={
                      data?.checkout.sistemaPagamento?.chiave === 'paypal_form'
                        ? 'paypal-form-submit-button'
                        : null
                    }
                    label={t('Conferma e procedi al pagamento')}
                    className="checkout-template__next"
                    disabled={!condizioni}
                    onClick={() => {
                      trackingGAevent(3, 'checkout', 'conferma', 'step4')
                      if (data?.checkout.sistemaPagamento?.chiave === 'paypal_form') {
                        // Il submit è gestito da PaypalForm
                        return
                      } else {
                        confirmOrder()
                      }
                    }}
                  />
                )}
              </div>
            )}
            <RiepilogoProdottiCheckout
              righeProdotti={data?.checkout.items}
              estero={data?.checkout.sistemaSpedizione.estero}
            />
          </div>
          <div className="checkout-template__riepilogo-mobile-bar">
            <div className="checkout-template__riepilogo-mobile-bar__totale">
              <span>
                <span>{t('Totale')}</span>
                <span className="checkout-template__riepilogo-mobile-bar__totale__iva-label">
                  ({t('IVA inclusa')})
                </span>
              </span>
              <span>{priceNotation(data?.checkout.totaleScontato)}</span>
            </div>
            {activeStepIndex === 2 && paypalClicked === false ? (
              <Button
                label={t("Procedi all'acquisto")}
                onClick={gotoPayment}
                className="checkout-template__riepilogo-mobile-bar__next"
              />
            ) : data?.checkout.sistemaPagamento?.chiave === 'paypal_login' ? (
              <div className="checkout-template__paypal">
                <PaypalButton
                  confirmOrder={() => setPaypalCompleted(true)}
                  isValid={
                    (!data?.checkout?.sistemaSpedizione.estero && !condizioni) ||
                    (data?.checkout?.sistemaSpedizione.estero &&
                      (data?.checkout?.erroreApisEstero || !condizioni))
                  }
                  fundingSource={FUNDING.PAYPAL}
                />
                <div className="checkout-template__paypal__message">
                  <PayPalMessage style={{ layout: 'text' }} forceReRender={[{ layout: 'text' }]} />
                </div>
              </div>
            ) : (
              <Button
                id={
                  data?.checkout.sistemaPagamento?.chiave === 'paypal_form'
                    ? 'paypal-form-submit-button-mobile'
                    : null
                }
                label={t('Concludi ordine')}
                className="checkout-template__riepilogo-mobile-bar__next"
                disabled={!condizioni}
                onClick={() => {
                  trackingGAevent(3, 'checkout', 'conferma', 'step4')
                  if (data?.checkout.sistemaPagamento?.chiave === 'paypal_form') {
                    // Il submit è gestito da PaypalForm
                    return
                  } else {
                    confirmOrder()
                  }
                }}
              />
            )}
          </div>
        </div>
      </div>
    </Page>
  )
}

export default CheckoutTemplate
